import React, { useEffect, useState } from "react"
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Helmet } from "react-helmet"

import InstagramIcon from "../../../assets/Instagram_icon-icons.com_66804.svg"
import { INSTAGRAM_URL } from "../../constants"

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "2rem",
    marginBottom: "2rem",
  },
  title: {
    color: "white",
    marginBottom: "2rem",
  },
}))

const InstagramImages = () => {
  const classes = useStyles()
  // Elfsightウィジェットが操作するDOMをReactのハイドレーション対象から
  // 外すため、クライアントでのマウント後にのみ描画する
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <div className={classes.root}>
      <Helmet>
        <script src="https://apps.elfsight.com/p/platform.js" defer></script>
      </Helmet>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.title}
      >
        <Grid item xs={5}>
          <Typography
            variant="body1"
            align="right"
            style={{
              fontSize: "2rem",
              textDecoration: "underline",
              fontFamily: "ヒラギノ丸ゴ ProN W4",
            }}
          >
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
              ギャラリー
            </a>
          </Typography>
        </Grid>
        <Grid item xs={2} container justifyContent="center" alignItems="center">
          <Grid item>
            <InstagramIcon
              style={{ width: "3rem", height: "3rem" }}
              aria-hidden="true"
            />
          </Grid>
        </Grid>
        <Grid item xs={5} align="left">
          <Typography
            variant="body1"
            style={{
              fontSize: "2rem",
              textDecoration: "underline",
              color: "cyan",
            }}
          >
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
              Go Instagram
            </a>
          </Typography>
        </Grid>
      </Grid>
      {mounted ? (
        <div className="elfsight-app-42fe86bd-9e8f-4b37-9529-d6dd39a381a8"></div>
      ) : (
        <Box align="center">
          <CircularProgress />
        </Box>
      )}
    </div>
  )
}

export default InstagramImages
